import * as ko from "knockout"
import {ICompanySyncstep, ICompanySyncstepParameter} from "../../../../../index";
import {Abstract} from "./Abstract";
import {createErrorMessage} from "../../../../../util/misc";
import detailsHtml from './details.html?raw';

export const template = detailsHtml;

interface IParams {
    companysyncstep: ICompanySyncstep
}

export class viewModel extends Abstract {

    private readonly isPasswordToggled: KnockoutObservable<boolean> = ko.observable(false)

    constructor(params: IParams) {
        super(params);
        this.init()
    }

    protected override init(): Promise<void> {
        return super.init()
            .then(() => this.loadClientCredentialContext())
            .then(() => this.loadMessageFlowContext())
            .then(() => {
                this.messageData(null)
                this.isReady(true)
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            })
    }

    private getDisplayValue(parameter: ICompanySyncstepParameter): string {
        if (String(this.getFormatType(parameter.keyvalue) ?? '').toLowerCase() === 'messagerefs') {
            const labelsById = new Map(this.messageFlowOptions().map(option => [option.idAsString, option.label]));
            return String(parameter.value ?? '')
                .split(',')
                .map(id => id.trim())
                .filter(Boolean)
                .map(id => labelsById.get(id) ?? `#${id}`)
                .join(', ');
        }
        if (!this.isClientCredentialRefKey(parameter.keyvalue)) {
            return parameter.value == null ? '' : String(parameter.value);
        }
        const id = parameter.value == null ? '' : String(parameter.value);
        return this.clientCredentialLabelById()[id] ?? id;
    }

}
